import { KeyboardManager } from 'managers/KeyboardManager'
import { PopupManager } from 'managers/PopupManager'
import { ToggleManager } from 'managers/SettingsManager'
import { initTweensManager } from 'managers/TweensManager'
import { FreespinsService } from 'services/FreespinsService'
import { ResizeService } from 'services/ResizeService'
import { ScatterService } from 'services/ScatterServise'
import { StoreageService } from 'services/StoreageService'
import { VisibilityService } from 'services/VisibilityService'
import { WinService } from 'services/WinService'

const name = 'PRE-SETUP'

async function execute() {
  game.models.BonusMultiplierModel.set(StoreageService.get('bonusMultiplier'))
  PopupManager.init()
  KeyboardManager.init() //check

  FreespinsService.init()
  ResizeService.init() // change
  VisibilityService.init()

  WinService.start()
  ScatterService.init()

  ToggleManager.init()
  initTweensManager()
}

export function getPreSetupAction() {
  return {
    name,
    execute,
  }
}
